import {
    AfterViewChecked,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    Output,
    QueryList,
    SimpleChange,
    ViewEncapsulation
} from '@angular/core';

import {TabComponent} from "../tab/tab.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ParentService} from "../../../services/mygreencountry/parent.service";
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    encapsulation: ViewEncapsulation.None
})


export class TabsComponent implements /*AfterContentInit,*/ AfterViewChecked {

    @Output() changeTab = new EventEmitter();
    @Input() styleProgress: boolean = false;
    @Input() styleGroup: boolean = false;
    @Input() showSchedule: boolean = false;
    @Input() studentStyle: boolean = false;


    constructor(private GCService: MyGreenCountry,
    ) {
    }

    ngAfterViewInit(): void {
        // get all active tabs
        let activeTabs = this.tabs.filter((tab) => tab.active);

        // if there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
    }

    @Input() navClass = '';

    @ContentChildren(TabComponent)
    tabs!: QueryList<TabComponent>;

    // set tabs!(value: QueryList<TabComponent>) {
    // }


    ngOnChanges(value: SimpleChange) {

    }


    // contentChildren are set
    /*ngAfterContentInit() {

        // get all active tabs
        let activeTabs = this.tabs.filter((tab) => tab.active);
        console.log('ngAfterContentInit');
        console.log(activeTabs);
        // if there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }

        this.tabs.changes.subscribe(

            data => {

                this.selectTab(this.tabs.first);

            }

        );


    }*/

    selectTab(tab: any) {
        // deactivate all tabs
        this.tabs.toArray().forEach(tab => tab.active = false);
        if (this.tabs.toArray().length > 0) {
            this.changeTab.emit(tab.time);
            // activate the tab the user has clicked on.
            tab.active = true;

            this.GCService.setActiveGroupTime(tab.time)
        }


    }

    ngAfterViewChecked(): void {
    }

}
